import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Grid2, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { buttonStyle, errorTextStyle, titleStyle } from '../../../utils/commonCSS'
import CustomTextField from '../../CustomTextField'
import CustomDropDown from '../../CustomDropDown'
import { taskTypeList, WORKerTypeList } from '../../../utils/constants'
import { createNewTask } from '../../../backend/backendApis'
import HttpService from '../../../backend/requestApis'
import { useNavigate } from 'react-router-dom'
import Loader from '../../Loader'

const NewTaskDialog = (props) => {

  const navigate = useNavigate()

  const [taskTitle, setTaskTitle] = useState('')
  const [taskTitleError, setTaskTitleError] = useState('')
  const [taskFor, setTaskFor] = useState('Select Assignee')
  const [taskForError, setTaskForError] = useState('')
  const [taskType, setTaskType] = useState('Select Task Type')
  const [taskTypeValue, setTaskTypeValue] = useState('')
  const [taskTypeError, setTaskTypeError] = useState('')
  const [taskLink, setTaskLink] = useState('')
  const [taskLinkError, setTaskLinkError] = useState('')
  const [taskCaption, setTaskCaption] = useState('')
  const [taskCaptionError, setTaskCaptionError] = useState('')
  const [isLoader, setIsLoader] = useState(false)
  const [apiError, setApiError] = useState('')

  const updateTaskTitle = (value) => {
    setTaskTitle(value)
  }

  const updateTaskFor = (value) => {
    setTaskFor(() => value)
  }

  const updateTaskType = (option) => {
    setTaskType(() => option.name)
    setTaskTypeValue(() => option.value)
  }

  const updateTaskLink = (value) => {
    setTaskLink(() => value)
  }

  const updateTaskCaption = (value) => {
    setTaskCaption(() => value)
  }

  function validateAdd(){
    let isValid = true
    if(taskTitle === ''){
      setTaskTitleError('Task Title is required.')
      isValid = false
    } else {
      setTaskTitleError('')
    }

    if(taskFor === 'Select Assignee'){
      setTaskForError('Select Asignee')
      isValid = false
    } else {
      setTaskForError('')
    }

    if(taskType === 'Select Task Type'){
      setTaskTypeError('Select Task Type')
      isValid = false
    } else {
      setTaskTypeError('')
    }

    if(taskTypeValue === 'socialMedia'){
      if(taskLink === ''){
        setTaskLinkError('Task Link cannot be Empty.')
        isValid = false
      } else {
        setTaskLinkError('')
      }

      if(taskCaption === ''){
        setTaskCaptionError('Task Caption cannot be Empty.')
        isValid = false
      } else {
        setTaskCaptionError('')
      }
    }
    return isValid
  }

  const handleAdd = () => {
    setIsLoader(true)
    let isValid = validateAdd()
    if( isValid){
      let options = {
        url: createNewTask,
        method: 'POST',
        payload: {
          taskTitle: taskTitle,
          taskCategory: taskTypeValue,
          assignedTo: taskFor,
          taskLink: taskLink,
          taskCaption: taskCaption
        },
        headers: {
          headers: {
            Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
          }
        }
      }
      HttpService(options).then(resp => {
        setIsLoader(false)
        props.updateDialogStatus(false, true)
      }).catch(err => {
        console.log("Error in creating and assigning the task: ", err)
        if(err?.status === 403){
          localStorage.clear()
          setIsLoader(false)
          navigate('/Login')
        } else {
          setIsLoader(false)
          setApiError('Error in Creating New tasks. Please Contact Support.')
        }
      })
    } else {
      setIsLoader(() => false)
    }
  }

  useEffect(() => {
    setTaskTitle('')
    setTaskTitleError('')
    setTaskFor('Select Assignee')
    setTaskForError('')
    setTaskType('Select Task Type')
    setTaskTypeValue('')
    setTaskTypeError('')
    setTaskLink('')
    setTaskLinkError('')
    setTaskCaption('')
    setTaskCaptionError('')
    setApiError('')
  }, [props?.dialogStatus])

  return (
    <>
        <Dialog maxWidth = 'sm' fullWidth open= {props.dialogStatus} onClose={() => {props.updateDialogStatus(false)}}>
            <DialogTitle style={titleStyle}>
                Add New Task
            </DialogTitle>
            <DialogContent>
                {isLoader && <Loader></Loader>}
                <Grid container spacing={1} sx={{padding: '1rem 0.5rem 1rem 0.5rem'}}>
                    <Grid item xs={12} sm={12}>
                        <CustomTextField regular={true}
                            placeHolder='Task Title'
                            value={taskTitle}
                            setFunc={updateTaskTitle}
                        ></CustomTextField>
                        <Typography style={{...errorTextStyle}}>
                          {taskTitleError}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sm ={6}>
                      <CustomDropDown list ={WORKerTypeList}
                        value= {taskFor}
                        placeHolder={'Select Assignee'}
                        setFunc={updateTaskFor}
                      >
                      </CustomDropDown>
                      <Typography style={{...errorTextStyle}}>
                          {taskForError}
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sm ={6}>
                      <CustomDropDown 
                        list ={taskTypeList}
                        isValueRequired={true}
                        value= {taskType}
                        placeHolder={'Select Task Type'}
                        setFunc={updateTaskType}
                      >
                      </CustomDropDown>
                      <Typography style={{...errorTextStyle}}>
                          {taskTypeError}
                        </Typography>
                    </Grid>
                    { taskType === 'Social Media' && 
                      <>
                        <Grid item xs={12} sm={12}>
                          <CustomTextField regular={true}
                            placeHolder = 'Task Link'
                            value = {taskLink}
                            setFunc = {updateTaskLink}
                          ></CustomTextField>
                          <Typography style={{...errorTextStyle}}>
                            {taskLinkError}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                          <CustomTextField regular={true}
                            placeHolder = 'Task Caption'
                            value = {taskCaption}
                            setFunc = {updateTaskCaption}
                          ></CustomTextField>
                          <Typography style={{...errorTextStyle}}>
                            {taskCaptionError}
                          </Typography>
                        </Grid>
                      </>

                    }

                </Grid>

                <Box style={{display: 'flex', justifyContent: 'center', padding: '0.5rem'}}>
                  <Typography style={{...errorTextStyle}}>
                    {apiError}
                  </Typography>
                </Box>

                <Box style={{display: 'flex', justifyContent: 'center'}}>
                  <Button style={buttonStyle}
                    onClick={() => {
                      handleAdd()
                    }}
                  > ADD</Button>

                </Box>

            </DialogContent>

        </Dialog>
    </>
  )
}

export default NewTaskDialog
